import React, { useEffect, useState, FC, useRef } from 'react';
import CustomSkeleton from 'components/Skeleton/Skeleton';
import { ChartDataset } from 'chart.js';
import { TopWorkflows } from 'components/Dashboard/index.type';
import Tabs from 'components/Graph/Tabs';
import Wrapper from 'components/Wrapper';
import BarGraph from 'components/Graph/BarGraph';
import moment from 'moment';

import DateRange from 'components/DateRange';
import { DateRanges } from 'components/WorkflowReports/index.type';

import { useOutsideClick } from 'app/hooks/useOutsideClick';
import Modal from 'components/Alert/Modal';

interface Props {
  topWorkflows: TopWorkflows;
  loading: boolean;
  
  onDateSelect: (start: string,end:string) => void;
}

const TopPerformanceWorkflows: FC<Props> = ({
  topWorkflows,
  loading,
  
  onDateSelect,
}) => {
  const [activeTab, setActiveTab] = useState<string>('Revenue');
  const [, setRedraw] = useState<boolean>(false);
  const [labels, setLabels] = useState<Array<string>>([]);
  const [graphData, setGraphData] = useState<Array<number>>([]);
  const [isFullView, setIsFullView] = useState(false);
  const outsideRef = useRef<HTMLDivElement>(null);
  const [dateRange, setDateRange] = useState<DateRanges>({
    startDate: moment(moment().format('YYYY-MM-DD'))
        .subtract(1, 'month')
        .toDate(),
    endDate: moment().toDate(),
});
  useOutsideClick(outsideRef, () => setIsFullView(false));


  const getPerformanceData = (tab?: string) => {
    setActiveTab(tab || 'Revenue');
    try {
      const orderLabels = topWorkflows.orders.map((order) => order.name);
      const revenueLabels = topWorkflows.revenue.map((order) => order.name);
      const aovLabels = topWorkflows.AOV.map((order) => order.name);

      if (tab === 'AOV') {
        setLabels(aovLabels);
        setGraphData(topWorkflows.AOV.map((revenue) => Number(revenue.value)));


      } else if (tab === 'Orders') {
        setLabels(orderLabels);
        setGraphData(
          topWorkflows.orders.map((revenue) => Number(revenue.value))
        );
      } else {
        setLabels(revenueLabels);
        setGraphData(
          topWorkflows.revenue.map((revenue) => Number(revenue.value))
        );
      }
    } catch (error) {
      console.log('error is: ', error);
    }
  };

  useEffect(() => {
    getPerformanceData();
    

  }, [topWorkflows]);

 

  return (
    <Wrapper parentClass="!mt-0 ">
      <div className="hover:rounded-lg hover:shadow-lg overflow-hidden hover:shadow-gray-200 dark:shadow-none hover:bg-white  dark:bg-transparent  storeTable">
        <div className="cardHeader flex-col sm:flex-row dark:border-[#fff]">
          <h4 className="text-base text-darkText font-medium dark:text-[#878A99] sm:mb-0 mb-4">
            Top Performance
          </h4>
          <div className='flex items-center sm:flex-row flex-col'>
            <Tabs
              activeTab={activeTab}
              onTabClick={(tab) => {
                if (tab === 'Revenue') {
                  setRedraw(true);
                } else {
                  setRedraw(false);
                }
                getPerformanceData(tab);
              }}
              tabs={['Revenue', 'Orders', 'AOV']}
            />
            <div className="pt-4">
              <DateRange
                dateRange={dateRange}
                onChangeRange={(range: DateRanges) => {
                  setDateRange(range);
                  onDateSelect(
                    moment(range.startDate).format('YYYY-MM-DD'),
                    moment(range.endDate).format('YYYY-MM-DD')
                  );
                }}
              />
            </div>
          </div>
        </div>
        <div onDoubleClick={() => setIsFullView(true)} className="px-4 pt-0 pb-10 h-[380px]">
          {loading ? (
            <CustomSkeleton columns={8} />
          ) : (
            <>
              <BarGraph
                height={186}
                chartLabels={labels}
                datasets={
                  [
                    {
                      data: graphData,
                      backgroundColor:
                        activeTab === 'Orders'
                          ? '#EC5E82'
                          : activeTab === 'AOV'
                            ? '#FBCC55'
                            : '#56C0C1',
                      barPercentage: 1,
                      barThickness: 25,
                    },
                  ] as ChartDataset<'bar', (number | [number, number] | null)[]>[]
                }
                style={{ width: '100%' }}
                hideLegend={true}
                isQuantitativeData={activeTab === 'Orders'}
              />
              <div className="flex justify-between items-center z-999999">
                <Modal isOpen={isFullView}>
                  <div ref={outsideRef} className="h-[70vh] mt-[140px] bg-white dark:bg-[url('assets/Images/Common/denimbg.webp')]  w-[70%] rounded p-6 mx-auto ">
                    <BarGraph
                      height={186}
                      chartLabels={labels}
                      datasets={
                        [
                          {
                            data: graphData,
                            backgroundColor:
                              activeTab === 'Orders'
                                ? '#EC5E82'
                                : activeTab === 'AOV'
                                  ? '#FBCC55'
                                  : '#56C0C1',
                            barPercentage: 1,
                            barThickness: 25,
                          },
                        ] as ChartDataset<'bar', (number | [number, number] | null)[]>[]
                      }
                      style={{ maxWidth: '100%', width: '100%' }}
                      hideLegend={true}
                      isQuantitativeData={activeTab === 'Orders'}
                    />
                  </div>
                </Modal>
              </div>
            </>
          )
          }
        </div>
      </div>
    </Wrapper>
  );
};
export default TopPerformanceWorkflows;
